// extracted by mini-css-extract-plugin
export default {"rootRemToPixelValue":"13","cardPaddingValue":".75","cardPaddingY":".75rem","cardPaddingX":".75rem","transitionDuration":"250","headerHeight":"53px","sidebarWidth":"200px"};